/**
 * @desc 更新新品下单状态
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: Array<defs.basics.UpdateProductOrderStatusRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/productOrder/updateStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
